module.exports = {
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  CLOUDFLARE_ACCOUNT_ID: process.env.REACT_APP_CLOUDFLARE_ACCOUNT_ID,
  CLOUDFLARE_LOCATIONS_KV_ID: process.env.REACT_APP_CLOUDFLARE_LOCATIONS_KV_ID,
  CLOUDFLARE_MENUS_KV_ID: process.env.REACT_APP_CLOUDFLARE_MENUS_KV_ID,
  CLOUDFLARE_KV_READ_TOKEN: process.env.REACT_APP_CLOUDFLARE_KV_READ_TOKEN,
}
